// This util will return white or black text color depending on the provided background color

// Get RGB of the color
function getRGB(c) {
  return parseInt(c, 16) || c
}

// Get sRGB of the color
function getsRGB(c) {
  return getRGB(c) / 255 <= 0.03928
    ? getRGB(c) / 255 / 12.92
    : Math.pow((getRGB(c) / 255 + 0.055) / 1.055, 2.4)
}

// Luminance of the color
function getLuminance(hexColor) {
  return (
    0.2126 * getsRGB(hexColor.substr(1, 2)) +
    0.7152 * getsRGB(hexColor.substr(3, 2)) +
    0.0722 * getsRGB(hexColor.substr(-2))
  )
}

function getContrast(foreground, background) {
  // relative luminance values of our two (foreground and background) colors
  const L1 = getLuminance(foreground)
  const L2 = getLuminance(background)
  // calculate the contrast between two colors
  return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05)
}

function getDynamicTextColor(bgColor) {
  const whiteContrast = getContrast(bgColor, '#ffffff')
  const blackContrast = getContrast(bgColor, '#000000')

  return whiteContrast > blackContrast ? '#ffffff' : '#000000'
}

export default getDynamicTextColor
